module.exports = __webpack_public_path__ + "img/educational_decree.6de82e36.jpg";